import React from 'react';
import icCarolus from '../../assets/logo_rs.png';
import icMed from '../../assets/medapp.png';
import icMedKecil from '../../assets/icon-medapp.png';
import { Typography } from '@material-ui/core';
import QRCode from "react-qr-code";
import Constant from '../../library/Constant';
import { format } from 'date-fns';
import { getAge } from '../../library/Util';

export class ComponentTiket extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visibleRegis: true,
      listResep: []
    }
  }

  componentDidMount() {
    this.setState({
      visibleRegis: this.props.pembayaran === 'umum' ? false : true
    })
    console.log(this.props);
  }

  componentDidUpdate() {
    console.log(this.props);
    if (this.props.idxCheck !== this.state.listResep) {
      this.setState({
        listResep: this.props.idxCheck
      })
    }
  }

  render() {
    return (
      <div className='print-source page-tiket'>
        {this.state.listResep.length > 0 && this.state.listResep.map((item, index) => {
          return (
            <div style={{ marginTop: index === 0 ? 0 : '10mm' }}>
              <div style={{ display: 'flex' }}>
                <img src={localStorage.getItem(Constant.LOGO_CETAKAN)} style={{ width: '3em', height: '4em', marginRight: '5mm' }} />
                <div style={{ display: 'grid', justifyContent: 'space-between', flex: 1 }}>
                  <Typography style={{ fontSize: '2mm', fontFamily: 'Poppins', textAlignLast: 'left', fontWeight: 'bold' }}>{localStorage.getItem(Constant.NAMA_RS)}</Typography>
                  <div>
                    <Typography style={{ fontSize: '2mm', fontFamily: 'Poppins', textAlignLast: 'left' }}>{localStorage.getItem(Constant.ALAMAT_RS)}</Typography>
                    <Typography style={{ fontSize: '2mm', fontFamily: 'Poppins', textAlignLast: 'left' }}>{localStorage.getItem(Constant.PHONE_RS)}</Typography>
                    <Typography style={{ fontSize: '2mm', fontFamily: 'Poppins', textAlignLast: 'left' }}>Apoteker : {this.props.detailResep.pharmacist}</Typography>
                    <Typography style={{ fontSize: '2mm', fontFamily: 'Poppins', textAlignLast: 'left' }}>{this.props.detailResep.sipa}</Typography>
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', marginTop: '2mm', justifyContent: 'space-between' }}>
                <Typography style={{ fontSize: '2.5mm', fontFamily: 'Poppins' }}>{this.props.detailResep.polyclinic}</Typography>
                <Typography style={{ fontSize: '2.5mm', fontFamily: 'Poppins', whiteSpace: 'nowrap' }}>No: {this.props.detailResep.code}</Typography>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography style={{ fontSize: '2.5mm', fontFamily: 'Poppins' }}>{this.props.detailResep.medical_record_no}</Typography>
                <Typography style={{ fontSize: '2.5mm', fontFamily: 'Poppins' }}>{this.props.detailResep.checkin_at === null ? "" : format(new Date(this.props.detailResep.checkin_at), 'dd-MM-yyyy')}</Typography>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography style={{ fontSize: '2.5mm', fontFamily: 'Poppins' }}>{format(new Date(this.props.detailResep.date_of_birth), 'dd-MM-yyyy')}</Typography>
                <Typography style={{ fontSize: '2.5mm', fontFamily: 'Poppins' }}>{item.medicine_type}</Typography>
              </div>
              <div style={{ display: 'flex', marginTop: '2mm', justifyContent: 'center' }}>
                <Typography style={{ fontSize: '2.8mm', fontFamily: 'Poppins' }}>{this.props.detailResep.patient}</Typography>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Typography style={{ fontSize: '2.8mm', fontFamily: 'Poppins' }}>{item.name}</Typography>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Typography style={{ fontSize: '2.8mm', fontFamily: 'Poppins' }}>{item.how_to_use}</Typography>
              </div>
              <div style={{ display: 'flex', marginTop: '2mm', justifyContent: 'space-between' }}>
                <Typography style={{ fontSize: '2.5mm', fontFamily: 'Poppins' }}>Kedaluwarsa: {this.props.detailResep.expired_date ? format(new Date(this.props.detailResep.expired_date), 'dd-MM-yyyy') : '-'}</Typography>
                {/* <div style={{ display: 'flex', justifyContent: 'space-between', width: '50%' }}> */}
                {/* <Typography style={{ fontSize: '2.5mm', fontFamily: 'Poppins' }}></Typography> */}
                <Typography style={{ fontSize: '2.5mm', fontFamily: 'Poppins' }}>Qty: {item.qty}, {item.medicine_unit}</Typography>
                {/* </div> */}
              </div>
            </div>
          )
        })}
      </div>
    );
  }
}